// buefy config
// see https://buefy.org/documentation/constructor-options
export default {
  // defaultFieldLabelPosition: 'on-border',
  defaultIconPack: 'mdi'
}
